import Vue from 'vue'
import vuetify from '../plugins/vuetify'

export function createComponent(component) {
    return new Vue({ vuetify, render: h => h(component) })
}

export function setValueById(id, value) {
    document.getElementById(id).innerText = value
}

export function addEventListenerById(event, id, cb) {
    document.getElementById(id).addEventListener(event, cb)
}